<template>
  <div class="fixed top-0 right-0 bototm-0 left-0 grid grid-cols-12 grid-rows-6 w-full h-full">
    <router-view></router-view>
    <Menus />
    <Loading :message="loading" />
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import Loading from './Loading.vue'
import Menus from './Menus.vue'

export default {
  name: 'Dashboard',
  data: () => ({
    profileMenuShow: false
  }),
  computed: {
    ...mapState(['auth']),
    ...mapGetters([
      'loading',
      'poi'
    ])
  },
  components: {
    Loading,
    Menus
  },
  methods: {
    ...mapActions(['toCheckAuth']),
    ...mapMutations(['setMessage']),

  },
  created: async function () {
    const checkAuth = await this.toCheckAuth('requiredTRUE')

    if (!checkAuth) {
      this.setMessage({
        text: 'silahkan login terlebih dahulu',
        status: 403
      })
      this.$router.push({ path: '/salmontrack/login' })
    }
  }
}
</script>
